import { StudyData } from "./deviceProgress";

export function plainRecord(feature: string, value: unknown): StudyData {
    if (!value || typeof value !== "object" || Array.isArray(value)) return {};
    const entries = Object.entries(value).filter(([key]) => !["__proto__", "constructor", "prototype"].includes(key));
    if (feature === "lessonParagraphNotes") return Object.fromEntries(entries.filter(([, note]) => {
        const data = note as { text?: unknown; updatedAt?: unknown } | null;
        return data && typeof data.text === "string" && typeof data.updatedAt === "string";
    }));
    if (feature === "kanjiMemoryGuessStats") return Object.fromEntries(entries.filter(([, data]) => data && typeof data === "object" && !Array.isArray(data)).map(([key, data]) => [key, plainRecord("counts", data)]));
    if (feature === "savedWords") return Object.fromEntries(entries.filter(([, item]) => item && typeof item === "object" && !Array.isArray(item) && typeof (item as { text?: unknown }).text === "string"));
    // Mirrors useWorksheetTemplates' own isWorksheetTemplate shape check - this
    // generic cross-feature sanitizer has no business importing a feature-specific
    // type guard, so the minimal shape is duplicated here instead. Without this
    // branch every template (an object, not a string) fell through to the default
    // string-only filter below and was silently wiped to {} on every cloud
    // hydration/sync round-trip - the root cause of saved templates disappearing.
    if (feature === "worksheetTemplates") return Object.fromEntries(entries.filter(([, item]) => {
        const candidate = item as { id?: unknown; name?: unknown; createdAt?: unknown; config?: unknown } | null;
        return Boolean(
            candidate && typeof candidate === "object" && !Array.isArray(candidate) &&
            typeof candidate.id === "string" && typeof candidate.name === "string" && typeof candidate.createdAt === "string" &&
            candidate.config && typeof candidate.config === "object" && !Array.isArray(candidate.config)
        );
    }));
    if (feature.endsWith("Counts") || feature === "counts") return Object.fromEntries(entries.filter(([, count]) => typeof count === "number" && Number.isFinite(count) && count >= 0));
    return Object.fromEntries(entries.filter(([, item]) => typeof item === "string"));
}
